export const TYPE_PAYMENT_METHOD = {
    SET_ALERT_MESSAGE: 'SET_ALERT_MESSAGE',
    SET_ALERT_LINK: 'SET_ALERT_LINK',
    SET_REFRESH_PAGE: 'SET_REFRESH_PAGE',
    SET_TEXT_ALERT_BUTTON: 'SET_TEXT_ALERT_BUTTON',
    SET_PAYMENT_METHOD: 'SET_PAYMENT_METHOD'
}